import { useTranslation } from 'react-i18next'

import { TruckIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Card, CardTitle } from '@reveni-io/reveni-ui'

import CardDescription from '@/metrics/components/CardDescription/CardDescription'
import MenuCard from '@/metrics/components/MenuCard/MenuCard'

import DeliveryMethodsList from './DeliveryMethodsList/DeliveryMethodsList'
import * as Styles from './styles'

const DeliveryMethodsCard = ({
  logisticsPreferences,
  deliveryMethods = [],
  carbonOffset,
  regions,
  loading,
  onExport,
  isUnifiedDashboard,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Card showBorder={false}>
      <CardTitle marginBottom={theme.spacing.sp16}>
        <Styles.Title>
          <TruckIcon size={24} />
          {t('Métodos de devolución')}
        </Styles.Title>
        <MenuCard cardName={t('Métodos de devolución')} onExport={onExport} />
      </CardTitle>
      <CardDescription>{t('Qué parte de las solicitudes recibidas usó cada método de devolución.')}</CardDescription>
      <DeliveryMethodsList
        loading={loading}
        deliveryMethods={deliveryMethods}
        logisticsPreferences={logisticsPreferences}
        carbonOffset={carbonOffset}
        regions={regions}
        isUnifiedDashboard={isUnifiedDashboard}
      />
    </Card>
  )
}

export default DeliveryMethodsCard
